import { PropType, computed, defineComponent, onUnmounted, reactive, ref, watch } from 'vue'
import { Store } from 'pinia'
import { ChargeMapContext } from '../../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../../nsh5/localStores/component'
import { MapViewMode } from '../../../contract/map'
import {
  DEFAULT_COUNTRY_ZOOM_LEVEL,
  DEFAULT_DISTRICT_ZOOM_LEVEL,
} from '../../../config/zoomLevelConfig'
import { calcSize, resizeMapResources } from '../../chargerMap/mapUtils'

export default defineComponent({
  name: 'county-layout-resource-dot-render-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },

  setup: (props) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    const zoomLevel = ref<number>(0)

    /**
     * 20250427 增加县县通功能
     * 初始化是不是要展示县县通模式下的小点
     * 切换县县通模式显示图层
     */
    const toggleCountyLayout = () => {
      if (zoomLevel.value === 0) {
        zoomEnd()
        return
      }
      if (
        props.componentStore.viewMode == MapViewMode.CountyLayout &&
        zoomLevel.value > DEFAULT_COUNTRY_ZOOM_LEVEL &&
        zoomLevel.value <= DEFAULT_DISTRICT_ZOOM_LEVEL
      ) {
        // 县县通模式下，省，市级别才展示小点
        if (
          props.componentStore.countyLayoutConfig.countyLayoutConfigList[
            props.componentStore.countyLayoutConfig.currentIndex
          ].itemCode === 'swap_station'
        ) {
          const swap = mapContextRef.value?.operatePointLayer('swap', true)
          mapContextRef.value?.operatePointLayer('charge', false)
          if (!swap) {
            // 修复小概率因网络问题初始化页面时，小点图层还未创建成功，导致地图上没有换电站小点
            setTimeout(() => {
              console.log('====================================')
              console.log('swap dot not ready, retry')
              console.log('====================================')
              mapContextRef.value?.operatePointLayer('swap', true)
            }, 2000)
          }
        }
        if (
          props.componentStore.countyLayoutConfig.countyLayoutConfigList[
            props.componentStore.countyLayoutConfig.currentIndex
          ].itemCode === 'charge_station'
        ) {
          mapContextRef.value?.operatePointLayer('swap', false)
          mapContextRef.value?.operatePointLayer('charge', true)
        }
      } else {
        mapContextRef.value?.operatePointLayer('swap', false)
        mapContextRef.value?.operatePointLayer('charge', false)
      }
    }

    // ------------暴露出去的方法--------------
    const zoomEnd = async () => {
      zoomLevel.value = mapInstance.value?.getZoom()
    }

    // 启动相关事件监听
    const initEventListener = () => {
      mapInstance.value?.addEventListener('zoomend', zoomEnd, false)
    }

    onUnmounted(() => {
      // 需要修正下首页点的大小
      resizeMapResources(mapContextRef.value!, calcSize(mapInstance.value?.getZoom()).w) // 调整点的大小
    })

    /**
     * 组件获取地图实例后的回调
     */
    const onReady = async () => {
      initEventListener()
    }
    watch(
      () => props.mapContextRef,
      () => {
        if (props.mapContextRef) {
          onReady()
        }
      },
      {
        immediate: true,
      }
    )

    watch(
      () => zoomLevel.value,
      () => {
        toggleCountyLayout()
      }
    )

    watch(
      () => props.componentStore.countyLayoutConfig.currentIndex,
      () => {
        toggleCountyLayout()
      },
      { immediate: true }
    )

    return () => {}
  },
})
